import React from 'react';

import ServiceList from '../containers/ServiceList';
import ServiceSearchInput from '../containers/ServiceSearchInput';

const Services = props => (
  <div>
    <div className="u-mv">
      <ServiceSearchInput />
    </div>
    <div className="u-mt">
      <ServiceList {...props} />
    </div>
  </div>
);

export default Services;
